var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var treeLocation = require('../../locations/treeLocationRoom');
var containsLocationModal = Object.assign(Object.create(Model) , require('../../../../../models/equipment/containsLocation'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


containsLocationModal.editDialogue = function (containsLocation, equipmentRecord, locationRecord, options) {
  Model.initForm.call(containsLocationModal, containsLocation);

  if (!containsLocation) {
    containsLocationModal.form.equipmentRecord(equipmentRecord);
    containsLocationModal.form.linkedLocation(locationRecord);
  }

  const submit = () => {
    var linkedLocationRecord = containsLocationModal.form.linkedLocation();
    var equipmentRecord = containsLocationModal.form.equipmentRecord();
    var equipmentRid = equipmentRecord && equipmentRecord['@rid'];

    if (!equipmentRid) {
      containsLocationModal.errors = ['Equipment record is required.'];
      m.redraw();
      return false;
    }

    if (!linkedLocationRecord || !linkedLocationRecord['@rid']) {
      containsLocationModal.errors = ['Select a location before saving.'];
      m.redraw();
      return false;
    }

    containsLocationModal.form.equipmentRecord(equipmentRid);
    containsLocationModal.form.linkedLocation(linkedLocationRecord['@rid']);
    return containsLocationModal.save()
    .then(response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback(linkedLocationRecord) : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(error => {
      containsLocationModal.form.equipmentRecord(equipmentRecord);
      containsLocationModal.form.linkedLocation(linkedLocationRecord);
      return Promise.reject(error);
    })
  };
  
  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(containsLocationModal.form['@rid'] && containsLocationModal.form['@rid']() ? 'Unlink Room: ' : 'Link Room: ');
  modal.vm.body = containsLocationModal.view;
  let buttons = [
  ]
  if (containsLocation) {
    buttons.push({
      label: "Unlink Location",
      class: "dib mr2 red",
      func: () => {
        return containsLocationModal.delete(containsLocation)
        .then(response => {
          key.unbind('enter');
          return Promise.resolve(options && options.submitCallback ? options.submitCallback() : null)
          .then(() => {
            modal.vm.close();
            m.redraw();
            return response;
          });
        })
      }
    })
  } else {
    buttons.push(
      {
        label: "Save",
        class: "dib green",
        func: submit
      }
    );

  }
  modal.vm.buttons(buttons);
  modal.vm.open();
}


containsLocationModal.view = function () {
  if (containsLocationModal.form['@rid'] && containsLocationModal.form['@rid']()) {
    return m('form', {role:'form'}, [
      containsLocationModal.errorView()
    ])
  } else {
    return m('form', {role:'form'}, [
      containsLocationModal.errorView(),
      m(treeLocation, {
        selectedNode: containsLocationModal.form.linkedLocation, 
        equipmentRecord: containsLocationModal.form.equipmentRecord
      })
    ])
  }
}

module.exports = containsLocationModal;
